import { render, staticRenderFns } from "./PanelCompetitionSetting.vue?vue&type=template&id=b2338796&scoped=true&"
import script from "./PanelCompetitionSetting.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSetting.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSetting.vue?vue&type=style&index=0&id=b2338796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2338796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2338796')) {
      api.createRecord('b2338796', component.options)
    } else {
      api.reload('b2338796', component.options)
    }
    module.hot.accept("./PanelCompetitionSetting.vue?vue&type=template&id=b2338796&scoped=true&", function () {
      api.rerender('b2338796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionSetting.vue"
export default component.exports